import { Routes, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Toaster } from 'react-hot-toast'
import HomePage from './components/HomePage'
import { AuthProvider } from './contexts/AuthContext'
import SiteSettingsProvider from './components/SiteSettingsProvider'
import ProtectedRoute from './components/admin/ProtectedRoute'
import AdminLogin from './components/admin/AdminLogin'
import AdminLayout from './components/admin/AdminLayout'
import AdminDashboard from './components/admin/AdminDashboard'
import ContentManagement from './components/admin/ContentManagement'
import ArtistManagement from './components/admin/ArtistManagement'
import ArtistForm from './components/admin/ArtistForm'
import MediaLibrary from './components/admin/MediaLibrary'

function App() {
  return (
    <>
      <Helmet>
        <title>O-Live Music - Bespoke Curation for Live Events</title>
        <meta 
          name="description" 
          content="O-Live Music - Bespoke Curation for Live Events. Professional live music booking for bars, restaurants, weddings, corporate events, and private parties. Perfect musicians for every occasion." 
        />
      </Helmet>
      
      <AuthProvider>
        <SiteSettingsProvider>
          <div className="App">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<HomePage />} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }>
                <Route index element={<AdminDashboard />} />
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="content" element={<ContentManagement />} />
                <Route path="artists" element={<ArtistManagement />} />
                <Route path="artists/add" element={<ArtistForm mode="add" />} />
                <Route path="artists/edit/:id" element={<ArtistForm mode="edit" />} />
                <Route path="media" element={<MediaLibrary />} />
                <Route path="settings" element={<div>Settings (Coming Soon)</div>} />
              </Route>
            </Routes>
          </div>
        </SiteSettingsProvider>
        
        {/* Toast Notifications */}
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
              borderRadius: '12px',
            },
          }}
        />
      </AuthProvider>
    </>
  )
}

export default App
